'use client';
import { deleteProductFee } from '@/services/cart';
import { toast } from 'sonner';
import { useMemo, useState } from 'react';
import { useLocale } from 'use-intl';
import CloseIcon from '../icons/close-icon';

const FeeCard = ({ index, item_id, t, info, refetchCart }) => {
  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const locale = useLocale();

  const service = useMemo(() => {
    return Object.values(info?.options || {})?.find((item) => item?.applied);
  }, [info?.options]);

  const handleDelFee = async (id) => {
    setLoading(true);
    const res = await deleteProductFee(id, item_id);

    if (res?.status === 200) {
      setLoading(false);
      toast.success(t('FeeDeleted'));
      refetchCart();
    } else {
      toast.success(t('FeeDeletedError'));
    }
  };
  return (
    service && (
      <button
        className={`${refetchCart ? 'cursor-pointer' : 'cursor-default'} relative flex basis-1/3 flex-col items-center justify-center gap-1 rounded-md border bg-white px-5 py-3 transition-all ${refetchCart && 'hover:border-primary-500'} max-sm:py-1.5 ${refetchCart && active === index && 'border-primary-500'} max-sm:basis-1/2`}
        onClick={() => refetchCart && setActive(index)}
      >
        {(service?.title || service?.title_ar) && (
          <span className='line-clamp-2 text-center text-sm max-sm:text-[10px]'>
            {locale === 'en'
              ? service?.title || service?.title_ar
              : service?.title_ar || service?.title}
          </span>
        )}
        {parseInt(service?.price) != 0 && (
          <span className='flex items-center justify-center gap-1 text-center font-bold max-sm:text-xs'>
            {Number(service?.price).toFixed(1)}$
          </span>
        )}
        {refetchCart ? (
          !loading ? (
            <CloseIcon
              onClick={() => handleDelFee(service?.fee_id)}
              className='absolute end-1 top-1 z-30 size-4 cursor-pointer text-red-600'
            />
          ) : (
            <span className='border-c_red-pure absolute end-1 top-1 z-30 size-4 animate-spin rounded-full border-t border-r max-lg:size-2' />
          )
        ) : null}
      </button>
    )
  );
};

export default FeeCard;
